import React, { useState, useEffect } from "react";
import { getAppResources, API_URL } from "../../services/api.js";
import { IoIosArrowDown, IoMdClose } from "react-icons/io";
import { azureDevopsImage } from "../../utils/constants.js";
import ResourceSynchronizationModal from "./ResourceSynchronizationModal.jsx"
import toast from "react-hot-toast";
import GithubReposWebhook from "./GithubReposWebhook.jsx";
import { HiViewBoards } from "react-icons/hi";
import { FiEdit3 } from "react-icons/fi";
import TeamsWebhooksManager from "./TeamsWebhookManager.jsx"

const configurationTitle = {
  "jira": "Jira Resources",
  "confluence": "Confluence Resources",
  "azure_devops": "Devops Organizations",
  "microsoft_outlook": "Outlook Configuration",
  "github": "Github Configuration",
  "gmail": "Gmail Configuration",
  "microsoft_teams": "Teams Configuration"
}

const ResourceModal = ({ appName, userGoogleId, onClose, onlyEmailApps}) => {
  const [resources, setResources] = useState([]);
  const [selectedResource, setSelectedResource] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [expandedResourceId, setExpandedResourceId] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0); // State to trigger re-render

  const [confirmLoading, setConfirmLoading] = useState(false);
  const [confirmSelectedProjectKey, setConfirmSelectedProjectKey] = useState(null);
  const [jiraSynced, setJiraSynced] = useState(false);
  const [foundJiraSync, setFoundJiraSync] = useState(false);

  const handleBulletClick = (e, key) => {
    e.stopPropagation();
    setFoundJiraSync(false)
    setJiraSynced(false)
    setConfirmSelectedProjectKey(key);
    handleConfirmSelection(true);
    setConfirmLoading(true);
  };


  console.log("APp Name:", appName)

  useEffect(() => {
    const fetchResources = async () => {
      try {
        setLoading(true);
        const response = await getAppResources(appName, userGoogleId);

        console.log("response:", response)

        // Normalize Azure DevOps and Jira data structure
        const normalizedResources =
          appName === "azure_devops"
            ? response.resources.map((org) => ({
              id: org.accountId,
              name: org.accountName,
              avatarUrl: azureDevopsImage,
              domainUrl: org.accountUrl,
              scopes: ["All"],
              organization: org.accountName,
            }))
            : appName === "jira" 
              ? response.resources.map((resource) => ({
                id: resource.id,
                name: resource.name,
                avatarUrl: resource.avatarUrl || null, // Add avatar for Jira if available
                domainUrl: resource.url,
                projects: resource.projects || [],
                selectedProject: resource.selected_project || {},

              }))
              : appName === "confluence"
              ? response.resources.map((resource) => ({
                  id: resource.id,
                  name: resource.name,
                  avatarUrl: resource.avatarUrl || null,
                  domainUrl: resource.url,
                  spaces: resource.spaces || [],
                  selectedSpace: resource.selected_space || {},
                }))
              : response.resources;
        console.log("Resources:", normalizedResources)

        const normalizedSelectedResource =
          appName === "azure_devops" && response.selected_resource
            ? {
              id: response.selected_resource.accountId,
              name: response.selected_resource.accountName,
              avatarUrl: azureDevopsImage,
              domainUrl: response.selected_resource.properties.accountUrl,
              scopes: ["All"],
              organization: response.accountName,
            }
            : appName === "jira"  ? {
              id: response.selected_resource.id,
              name: response.selected_resource.name,
              avatarUrl: response.selected_resource.avatarUrl || null,
              domainUrl: response.selected_resource.url,
              projects: response.selected_resource.projects || [],
              selectedProject: response.selected_resource.selected_project || {},
              // scopes: ["All"],
              // organization: response.accountName,
            } : appName === "confluence"
            ? {
                id: response.selected_resource.id,
                name: response.selected_resource.name,
                avatarUrl: response.selected_resource.avatarUrl || null,
                domainUrl: response.selected_resource.url,
                spaces: response.selected_resource.spaces || [],
                selectedSpace: response.selected_resource.selected_space || {},
              }
            : response.selected_resource;
        console.log("Selected Resource:", normalizedSelectedResource)

        setResources(normalizedResources);
        setSelectedResource(normalizedSelectedResource);
        setConfirmSelectedProjectKey(normalizedSelectedResource?.selectedProject?.key || null);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    if (["jira", "confluence", "azure_devops"].includes(appName)) {
      fetchResources();
    }

  }, [appName, userGoogleId]);

  const handleSelectResource = (resourceId) => {
    const resource = resources.find((res) => res.id === resourceId);
    setSelectedResource(resource);
  };

  const handleSelectProject = (projectKey) => {
    setSelectedResource((prev) => ({
      ...prev,
      selectedProject: prev.projects.find((proj) => proj.key === projectKey),
    }));

  };



    // New: Function to select a space for Confluence
    const handleSelectSpace = (spaceKey) => {
      setSelectedResource((prev) => ({
        ...prev,
        selectedSpace: prev.spaces.find((space) => space.key === spaceKey),
      }));
    };

  // New: Function to select a board for the currently selected project
  const handleSelectBoard = (boardId) => {
    setSelectedResource((prev) => {
      const updatedProject = {
        ...prev.selectedProject,
        selected_board: prev.selectedProject.boards.find((board) => board.id === boardId),
      };
      return { ...prev, selectedProject: updatedProject };
    });
  };

  const handleConfirmSelection = async (doNotClose = false) => {
    try {
      const body =
        appName === "jira"
          ? {
              selected_resource_id: selectedResource.id,
              project_key: selectedResource.selectedProject.key,
              board_key: selectedResource.selectedProject.selected_board?.id,
            }
          : appName === "confluence"
          ? {
              selected_resource_id: selectedResource.id,
              space_key: selectedResource.selectedSpace.key,
            }
          : { selected_resource_id: selectedResource.id };

      const response = await fetch(`${API_URL}/auth/${appName}/resources/select`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${userGoogleId}` },
        body: JSON.stringify(body),
        credentials: "include"
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to update selection");
      }

      if (!doNotClose){
      onClose(); // Close the modal on successful selection
      } else {
        setRefreshKey((prev) => prev + 1);
      }

    } catch (error) {
      setError(error.message);
    }
  };

  const toggleDetails = (resourceId) => {
    setExpandedResourceId(expandedResourceId === resourceId ? null : resourceId);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
      <div className="bg-2 border border-zinc-700 min-w-[40%] max-h-[90%] rounded-lg p-6 relative shadow-2xl shadow-zinc-800  flex flex-col">
        {/* Close Icon at Top Right */}
        <button onClick={onClose} className="absolute top-4 right-4 text-zinc-500">
          <IoMdClose size={24} />
        </button>

        <h2 className="text-md font-semibold text-zinc-200 mt-4 md:mt-0 mb-4">
          {configurationTitle[appName]}
        </h2>
        {["jira", "confluence", "azure_devops", "microsoft_outlook", "gmail"].includes(appName) && (
           <div className="flex-grow overflow-auto">

            {loading ? (
              <p>Loading resources...</p>
            ) : error ? (
              <p className="text-red-500">{error}</p>
            ) : (
              <>
                <div className="mb-4 space-y-3">
                  {resources.map((resource) => (
                    <div
                      key={resource.id}
                      className={`border border-zinc-700 rounded-lg cursor-pointer ${selectedResource?.id === resource.id
                        ? "bg-zinc-800 text-white shadow-lg"
                        : "bg-zinc-900 text-zinc-200"
                        }`}
                      
                    >
                      <div 
                      onClick={() =>{
                        handleSelectResource(resource.id)
                       }}
                      className="flex justify-between items-center p-2 ">
                        <div className="flex items-center gap-2">
                          {resource.avatarUrl && (
                            <img
                              src={resource.avatarUrl}
                              alt={`${resource.name} avatar`}
                              className="h-8 w-8 rounded-full"
                            />
                          )}
                          <span className="font-medium text-zinc-200">{resource.name}</span>
                        </div>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleDetails(resource.id);
                          }}
                          className={`rounded-full text-sm hover:bg-zinc-700 font-semibold ease-in-out transform transition-all duration-300 p-2 ${expandedResourceId === resource.id ? "rotate-180" : "rotate-0"
                            }`}
                        >
                          <IoIosArrowDown />
                        </button>
                      </div>

                      {expandedResourceId === resource.id && appName === "jira" && (
                        <div key = {refreshKey} className="flex flex-col gap-2 text-sm text-zinc-300 bg-zinc-800 p-3 rounded-b-lg border-t border-zinc-700  ">
                          <div className="flex items-center justify-between px-3 py-2 w-full bg-2  rounded-lg">
                            <strong className="text-zinc-200">Domain</strong>{" "}
                            <a
                              href={resource.domainUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-400 underline"
                            >
                              {resource.domainUrl}
                            </a>
                          </div>
                          <div className="bg-2 shadow-md text-zinc-200 shadow-zinc-800 rounded-lg">
                            <div className="flex items-center px-2 py-2 w-full bg-2 rounded-t-lg border-b border-zinc-700 ">
                              <div className="text-md ">Projects</div>
                            </div>
                            <ul className="mt-1 p-2">
                              {resource.projects.map((project) => (
                                <li
                                  key={project.key}
                                  className={`cursor-pointer border border-zinc-700 rounded-lg mb-2 ${selectedResource?.selectedProject?.key === project.key
                                    ? " text-gray-100 "
                                    : ""
                                    }`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSelectProject(project.key);
                                  }}
                                >
                                  {/* {project.name} ({project.key}) */}

                                  <div className={`relative flex items-center justify-between cursor-pointer px-3 py-2 text-sm w-full overflow-hidden
                                    ${selectedResource?.selectedProject?.key === project.key
                                      ? "bg-zinc-700  font-semibold rounded-t-lg"
                                      : "text-gray-100 hover:bg-zinc-900 rounded-lg"}`}>
                                    {/* {selectedResource?.selectedProject?.key === project.key && confirmLoading && (
                                      <div className="absolute top-0 left-0 w-full h-1 bg-[#5652CF] animate-pulse rounded-t-lg"></div>
                                    )} */}

                                    <div>{project.name} ({project.key})</div>

                                    <div className="flex gap-3 items-center">

                                      {confirmSelectedProjectKey === project.key && jiraSynced && <div
                                        className={`  rounded-full flex items-center justify-center cursor-pointer  ${isDialogOpen && "bg-2 "} hover:bg-2`}
                                        onClick={() => { setIsDialogOpen(true) }}
                                      >
                                        <FiEdit3 size={18} />
                                      </div>}

                                      { (selectedResource?.selectedProject?.key === project.key || confirmSelectedProjectKey === project.key ) &&  (
                                       confirmLoading  ? (
                                        <div className="h-5 w-5 rounded-full border-2 border-green-500 border-t-transparent animate-spin" />
                                      ) : (
                                        <div
                                          className={`h-5 w-5 rounded-full border-2 flex items-center justify-center cursor-pointer transition-colors duration-300 ${confirmSelectedProjectKey === project.key ? "border-green-500 shadow-sm shadow-green-800" : "border-gray-500"
                                            }`}
                                          onClick={(e) => {
                                            
                                            handleBulletClick(e, project.key)
                                          }}
                                        >
                                          {confirmSelectedProjectKey === project.key && (
                                            <div className="h-2 w-2 bg-green-500 rounded-full" />
                                          )}
                                        </div>
                                      ) )}

                                    </div>
                                  </div>

                                  {selectedResource?.selectedProject?.key === project.key && (
                                    <div className="mt-2 p-2 ease-in-out transform transition-all duration-700 ">
                                      <div className="flex items-center text-zinc-500 gap-2 font-semibold "> <HiViewBoards size={20} /> Boards</div>
                                      <ul className="mt-2 space-y-2">
                                        {project.boards.map((board) => (
                                          <li
                                            key={board.id}
                                            className={`cursor-pointer text-xs rounded-lg px-2 py-2  ${selectedResource.selectedProject.selected_board?.id === board.id
                                              ? "text-white font-semibold bg-blue-900"
                                              : "text-zinc-400 bg-zinc-800 "
                                              }`}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleSelectBoard(board.id);
                                            }}
                                          >
                                            {board.name}
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                      {expandedResourceId === resource.id && appName === "confluence" && (
                        <div className="mt-2 text-sm bg-zinc-800 p-3 rounded-lg">
                          <p>
                            <strong>Domain:</strong>{" "}
                            <a href={resource.domainUrl} target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">
                              {resource.domainUrl}
                            </a>
                          </p>
                          <p>
                            <strong>Spaces:</strong>
                          </p>
                          <ul className="ml-4 mt-1">
                            {resource.spaces.map((space) => (
                              <li
                                key={space.key}
                                className={`cursor-pointer ${selectedResource?.selectedSpace?.key === space.key ? "text-white font-semibold" : "text-zinc-400"}`}
                                onClick={(e) => { e.stopPropagation(); handleSelectSpace(space.key); }}
                              >
                                {space.name} ({space.key})
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                    </div>
                  ))}
                </div>
                <div className={`flex ${["microsoft_outlook", "gmail"].includes(appName) ? "justify-start" : ["jira"].includes(appName) ? "justify-between" : "justify-end"}`}>
                  {appName === "jira" ? (
                    <button
                      key={refreshKey}
                      className={` bg-zinc-800 hover:bg-zinc-700 text-white py-2 px-4 rounded-md transition duration-150 ${(!foundJiraSync || jiraSynced) && " opacity-0"}`}
                      onClick={() => { setIsDialogOpen(true) }}
                      disabled={!selectedResource?.selectedProject || jiraSynced || !foundJiraSync}
                    >
                      Synchronize
                    </button>
                  ) : (

                    (appName === "jira" || appName === "microsoft_outlook" || appName === "gmail") &&
                    <button
                      key={refreshKey}
                      className="bg-zinc-800 hover:bg-zinc-700 text-white py-2 px-4 rounded-md transition duration-150"
                      onClick={() => { setIsDialogOpen(true) }}
                      disabled={(appName === "jira" && !selectedResource?.selectedProject)}
                    >

                      {selectedResource?.selectedProject?.synchronized ? "Synchronized" : "Synchronize"}

                    </button>
                  )
                  }
                  {resources?.length > 0 &&
                    <button
                      className={` bg-zinc-800 hover:bg-zinc-700 text-white py-2 px-4 rounded-md transition duration-150 ${appName == "jira" && "opacity-0"} `}
                      onClick={() => {
                        if (appName === "jira") {
                          handleConfirmSelection(true);
                        } else {
                          handleConfirmSelection();
                        }
                      }}
                      disabled={!selectedResource || (appName === "jira" && !selectedResource.selectedProject)}
                    >
                      {confirmLoading ? "Confirming.." : "Confirm Selection"}
                    </button>
                  }
                </div>
              </>
            )}
          </div>)}
          {appName === "github" && 
          <GithubReposWebhook />  
          }
          {appName === "microsoft_teams" && 
          <TeamsWebhooksManager />  
          }
      </div>
      {["jira", "microsoft_outlook", "gmail"].includes(appName) &&
        <ResourceSynchronizationModal
          key={refreshKey}
          isOpen={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          appName={appName}
          onlyEmailApps={onlyEmailApps}
          setJiraSynced={setJiraSynced}
          jiraSynced={jiraSynced}
          setFoundJiraSync={setFoundJiraSync}
          setConfirmLoading={setConfirmLoading}
        />
      }

    </div>
  );
};

export default ResourceModal;